var _StreamServiceInit_locals, _StreamServiceInit_externals;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
class StreamServiceInit {
    constructor() {
        _StreamServiceInit_locals.set(this, writable([]));
        _StreamServiceInit_externals.set(this, writable([]));
    }
    get locals() {
        return __classPrivateFieldGet(this, _StreamServiceInit_locals, "f");
    }
    get externals() {
        return __classPrivateFieldGet(this, _StreamServiceInit_externals, "f");
    }
    setLocals(locals) {
        __classPrivateFieldGet(this, _StreamServiceInit_locals, "f").set(locals);
    }
    setExternals(externals) {
        __classPrivateFieldGet(this, _StreamServiceInit_externals, "f").set(externals);
    }
}
_StreamServiceInit_locals = new WeakMap(), _StreamServiceInit_externals = new WeakMap();
export const StreamService = new StreamServiceInit();
